export default __webpack_public_path__ + "static/media/driver.ca3794b7.svg";